import { SET_CURRENT_YEAR, SET_EMISSION_BASED } from 'redux/action/type'
import { CURRENT_YEAR_OPTION } from 'utils/constants/common'
import { EMISSION_BASED } from 'utils/constants/enums'

interface IDashboardState {
  year: string
  emissionBased: EMISSION_BASED
}

interface DashBoardAction {
  type: string
  payload: IDashboardState
}

const initialState: IDashboardState = {
  year: CURRENT_YEAR_OPTION.value,
  emissionBased: EMISSION_BASED.MARKET,
}

const dashboardReducer = (
  state: IDashboardState = initialState,
  action: DashBoardAction,
): IDashboardState => {
  switch (action.type) {
    case SET_CURRENT_YEAR:
      return {
        ...state,
        year: action.payload.year,
      }
    case SET_EMISSION_BASED:
      return {
        ...state,
        emissionBased: action.payload.emissionBased,
      }
    default:
      return state
  }
}

export default dashboardReducer
